import { render, staticRenderFns } from "./TeacherAudit.vue?vue&type=template&id=20a0b37e"
import script from "./TeacherAudit.vue?vue&type=script&lang=js"
export * from "./TeacherAudit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports